import { handleActions } from 'redux-actions';
import { setAddWish, clearAddWish } from './actions';

const defaultState = {
  url: '',
  price: null,
  currency: 'euro',
  imageUrl: '',
  visible: true,
  from: 'germany'
};

export default handleActions({
  [setAddWish]: (state, { payload }) => ({ ...state, ...payload }),
  [clearAddWish]: () => defaultState
}, defaultState);



// WEBPACK FOOTER //
// ./src/store/addWish/reducer.js